import { useQuery } from '@tanstack/react-query';

import type { DirectoryEntry } from '@/components/advisor/public/AdvisorCardGrid';
import { getBackendHost } from '@/lib/api-client';

export function publicApiBaseUrl() {
  const { hostname, protocol, port } = window.location;
  const backendPort = protocol === 'http:' && port ? ':8080' : '';
  return `${protocol}//${getBackendHost(hostname)}${backendPort}/api/frontend`;
}

export async function fetchPublicAdvisors(): Promise<DirectoryEntry[]> {
  const res = await fetch(`${publicApiBaseUrl()}/public/advisors/`);
  if (!res.ok) throw new Error(`public directory answered ${res.status}`);
  const data = await res.json();
  return Array.isArray(data) ? data : data.results ?? [];
}

export function usePublicAdvisors() {
  return useQuery({ queryKey: ['public-advisors'], queryFn: fetchPublicAdvisors, staleTime: 5 * 60 * 1000 });
}
